module.exports = __webpack_public_path__ + "img/forgetPass1.9d2ed9ad.png";